import { render, staticRenderFns } from "./ComplianceExternal.vue?vue&type=template&id=2a720467"
import script from "./ComplianceExternal.vue?vue&type=script&lang=js"
export * from "./ComplianceExternal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports